import { render, staticRenderFns } from "./HubFileInput.vue?vue&type=template&id=2c94493b&scoped=true&"
import script from "./HubFileInput.vue?vue&type=script&lang=ts&"
export * from "./HubFileInput.vue?vue&type=script&lang=ts&"
import style0 from "./HubFileInput.vue?vue&type=style&index=0&id=2c94493b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c94493b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
